import { useTerms } from "../../js/shared/terms";

export function TermsProvider({ slug, children }) {
	const terms = useTerms(slug);

	return children(terms);
}